import { DiceTemplate } from "@kosmod/andy";
import { Logic, MiniModel, MiniSprite, MiniTemplate, TerrainBrush, theatreAPI } from "../defs";
import { AssetReference, GameAssetClient } from "@kosmod/assets";
import { K3D } from "@kosmod/graphics-3d";
import { Game } from "@kosmod/sesame";
import { HttpApi } from "@kosmod/pancake";
import { TheatreController, TheatreData } from ".";

export const useTheatreContentManager = (
  game: Game,
  { miniModels, miniSprites, miniTemplates, diceTemplates, brushes }: TheatreData,
  { refresh }: TheatreController,
  assets: GameAssetClient,
  api: HttpApi.Client<typeof theatreAPI>,
) => {

  return {
    async createNewMiniSprite(imageAsset: AssetReference, imageArea: K3D.Box2 | null = null): Promise<MiniSprite> {
      const { body: { miniSprite } } = await api["mini/sprites"].POST({ body: { imageArea, imageAsset, game: game.id }})

      return miniSprite;
    },
    async createNewMiniModel(modelAsset: AssetReference, modelPath: string[]): Promise<MiniModel> {
      const { body: { miniModel } } = await api["mini/models"].POST({ body: { modelAsset, modelPath, game: game.id }})

      return miniModel;
    },
    async createNewMiniTemplate(name: string, logic: Logic.Any[]): Promise<MiniTemplate> {
      const { mini } = await api["mini/templates"].POST(null, { name, game: game.id, logic })

      return mini;
    },
    async updateMiniTemplate(miniTemplate: MiniTemplate): Promise<void> {
      await api["mini/templates"].PUT(
        { game: miniTemplate.game, templateId: miniTemplate.id },
        miniTemplate
      )
    },
    async createNewDiceTemplate(): Promise<DiceTemplate> {
      throw new Error();
    },
    async createNewTerrainBrush(): Promise<TerrainBrush> {
      throw new Error();
    },
    assets,
    miniModels,
    miniSprites,
    miniTemplates,
    diceTemplates,
    brushes,

    refresh,
  }
};
export type TheatreContentManager = ReturnType<typeof useTheatreContentManager>;
